/** Google Maps JS API bootstrap loader (https://developers.google.com/maps/documentation/javascript/load-maps-js-api). */
export function initGoogleMapsLoader(apiKey: string): void {
  ((g: { v: string; key: string }) => {
    let h: Promise<void> | undefined;
    let a: HTMLScriptElement;
    let k: string;
    const p = 'The Google Maps JavaScript API';
    const c = 'google';
    const l = 'importLibrary';
    const q = '__ib__';
    const m = document;
    const b = (window as unknown as Record<string, unknown>)[c] || ((window as unknown as Record<string, unknown>)[c] = {});
    const d = (b as { maps?: Record<string, unknown> }).maps || ((b as { maps: Record<string, unknown> }).maps = {});
    const r = new Set<string>();
    const e = new URLSearchParams();
    const u = () =>
      h ||
      (h = new Promise<void>(async (f, n) => {
        a = m.createElement('script');
        e.set('libraries', [...r] + '');
        for (k in g) {
          e.set(
            k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
            g[k as keyof typeof g]
          );
        }
        e.set('callback', c + '.maps.' + q);
        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
        (d as Record<string, unknown>)[q] = f;
        a.onerror = () => {
          h = undefined;
          n(new Error(p + ' could not load.'));
        };
        a.nonce = (m.querySelector('script[nonce]') as HTMLScriptElement | null)?.nonce || '';
        m.head.append(a);
      }));
    if (d[l]) {
      console.warn(p + ' only loads once. Ignoring:', g);
    } else {
      (d as Record<string, unknown>)[l] = (f: string, ...n: unknown[]) =>
        r.add(f) && u().then(() => (d as Record<string, (...args: unknown[]) => unknown>)[l](f, ...n));
    }
  })({
    v: 'weekly',
    key: apiKey
  });
}
